import { Box, Snackbar, Alert } from '@mui/material';
import { LoadingSkeleton, TableTitleBox } from '../../common/components';
import LifeInsuranceHeader from './components/LifeInsuranceHeader';
import LifeInsuranceTable from './components/LifeInsuranceTable';
import LifeInsurancePagination from './components/LifeInsurancePagination';
import LifeInsuranceImportDialog from './components/LifeInsuranceImportDialog';
import { useLifeInsurance } from './hooks/useLifeInsurance';

const LifeInsurance = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    plans,
    groups,
    handleFilter,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleDownloadExcel,
    handleDownloadExcelForInsurer,
    selectedFile,
    tableData,
    importDialogOpen,
    importLoading,
    snackbar,
    handleFileUpload,
    handleImportValues,
    handleCloseImportDialog,
    handleUpload,
    handleCloseSnackbar,
  } = useLifeInsurance();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <TableTitleBox title="Contrato | Seguro de vida" />

      <LifeInsuranceHeader
        filter={filter}
        plans={plans}
        groups={groups}
        onFilter={handleFilter}
        onSearch={handleSearch}
        onDownloadExcel={handleDownloadExcel}
        onDownloadExcelForInsurer={handleDownloadExcelForInsurer}
        isLoading={isLoading}
        selectedFile={selectedFile}
        onFileUpload={handleFileUpload}
        onImportValues={handleImportValues}
      />

      <LifeInsuranceTable data={data} isLoading={isLoading} LoadingComponent={LoadingSkeleton} />

      <LifeInsurancePagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <LifeInsuranceImportDialog
        open={importDialogOpen}
        onClose={handleCloseImportDialog}
        tableData={tableData}
        loading={importLoading}
        onUpload={handleUpload}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LifeInsurance;
